<template>
<div>
    <div id="contents" v-show="mode === MODE.SEARCH">
        <div class="contents_wrap" >
            <h2 class="pg_title">
                <!-- 활성화된 링크에 active -->
                <a href="javascript:" class="" @click="moveknowledge($event)">Service Bulletin - List</a>
                <a href="javascript:" class="active">Mobile (English)</a>
            </h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w100">
                            <li class="tit_150" data-input-type="select">
                                <select class="slt_white w140p" v-model="SEARCH">
                                    <option value="Title+Keyword" selected>Title + Keyword</option>
                                    <option value="Title">Title</option>	            			
                                </select>
                            </li>
                            <li class="srch_a" data-input-type="input">
                                <span class="clearable">
                                    <input type="text" class="text_input w100"
                                        placeholder="Title"
                                        v-model="TITLE"
                                        v-clearable
                                        />
                                </span>
                            </li>
                        </ul>
                        <ul class="w100">
                            <li class="tit_150">Reg/Updated Date</li>
                            <li data-input-type="date">
                                <fieldset class="ui_fieldset">
                                    <label class="date-wrap">
                                        <input
                                            id="fromDate"
                                            type="text"
                                            class="date_input w100"
                                            placeholder="From Date"
                                            maxlength="12"
                                            readonly
                                        />
                                        <a href="javascript:" class="in_btn" id="icoFromDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">Open Calendar</span>
                                        </a>
                                    </label>
                                    <div id="from-picker-container" />
                                    <em class="txt_space"></em>
                                    <label class="date-wrap">
                                        <input
                                            id="toDate"
                                            type="text"
                                            class="date_input w100"
                                            placeholder="Until Date"
                                            maxlength="12"
                                            readonly
                                        />
                                        <a href="javascript:" class="in_btn" id="icoToDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">Open Calendar</span>
                                        </a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;" />
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Urgency</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="URGENCY">
                                    <option value="">All</option>
                                    <option value="Y">Y</option>
                                    <option value="N">N</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">User Level</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="USER_LEVEL">
                                    <option
                                        v-for="item in userLevelList"
                                        :key="item.CODE_ID"
                                        :value="item.CODE_ID"
                                    >{{item.CODE_NAME}}</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Type1</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="TYPE1">
                                    <option value="">ALL</option>
                                    <option value="Guide">Guide</option>
                                    <option value="Bulletin">Bulletin</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Type2</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-if="TYPE1 === ''" v-model="TYPE2_G">
                                    <option value="" selected>ALL</option>
                                </select>
                                <select class="slt_white w100" v-if="TYPE1 === 'Guide'" v-model="TYPE2_G">
                                    <option value="" selected>ALL</option>
                                    <option value="Common">Common</option>
                                    <option value="IMEI">IMEI</option>
                                    <option value="Policy / Process">Policy / Process</option>
                                    <option value="SW Tool">SW Tool</option>
                                    <option value="Jig / Equipment">Jig / Equipment</option>
                                    <option value="Training Material">Training Material</option>
                                </select>
                                <select class="slt_white w100" v-if="TYPE1 === 'Bulletin'" v-model="TYPE2_B">
                                    <option value="" selected>ALL</option>
                                    <option v-for="item in bulletinType2List" :key="item" :value="item">{{item}}</option>
                                </select>

                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Modified</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="MODIFIED">
                                    <option value="">All</option>
                                    <option value="Y">Y</option>
                                    <option value="N">N</option>
                                </select>
                            </li>
                        </ul>
                    </div>
                    <div class="srch_grupR">
                        <span class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearchClick">Search</a>
                        </span>
                    </div>
                </article>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <!-- Grid Count-->
                <div class="grid_total">
                    Total Count
                    <em>{{ resultCount | numberFormat }}</em>
                </div>
                <!-- Grid "btn-->
                <div class="btn_wrap" v-if="['S05'].includes(roleCd)">
                    <a href="javascript:" class="btn_gray" title @click="$router.push({name:'hhpServiceBulletinCreate'})">Create</a>
                </div>
                <!-- Grid -->
                <div id="grid">
                    <toast-grid
                        gridId="gridBulletin"
                        ref="gridBulletin"
                        :key="gridKey"
                        :data="gridData"
                        :columns="gridColumns"
                        :header="gridHeader"
                        :options="gridOptions"
                        :pageOptions="gridPageOptions"
                        :theme="gridTheme"
                        :isTotalCount="false"
                        v-bind:click="onGridCellClick"
                    />
                </div>

                <div class="paginate">
                    <sdl-pagination
                        :current-page="currentPage"
                        :total-rows="resultCount"
                        :per-page="perPage"
                        @change="onGoToPage"
                        align="center"
                    />
                </div>
            </div>

        </div>
    </div>
    <bulletin-view v-if="mode === MODE.VIEW" :seq="view.seq" :onBackToList="onBackToList" />
</div>

</template>

<script>
import Vue              from 'vue';

import { mapGetters } from 'vuex';

import axios from 'axios';
import qs from 'query-string';
import moment from 'moment';

import { SDLUtil, StringUtil, DateUtil } from '@/utils';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import DatePicker from '~c/DatePicker';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import { CellHtmlRenderer, HeaderHtmlRenderer, } from '~c/GridCustomRenderer';

import BulletinView from './BulletinView';
import ApprovalHistoryPopup                 from '~c/popup/ApprovalHistoryPopup';

const MODE = {
    SEARCH: 1,
    VIEW: 2,
};

export default {
    name: '',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
        'bulletin-view': BulletinView,
    },
    created() {},
    data() {
        return {
            ...mapGetters({
                locale: 'getLocale',
                getMenus: 'getMenus',
            }),
            MODE,
            mode: MODE.SEARCH,

            view: {
                seq: '',
            },

            roleCd: '', // my Role Code

            SEARCH: 'Title+Keyword',
            TITLE: '',
            TYPE1: '',
            TYPE2: '',
            TYPE2_B: '',
            TYPE2_G: '',
            URGENCY: '',
            USER_LEVEL: '',
            MODIFIED: '',

            rangePicker: null,
            startDate: {},
            endDate: {},
            searchToAddDt: '',
            searchFromAddDt: '',

            bulletinType2List: [],
            userLevelList: [],

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],

            gridHeader: {
                // height: 100,
                //complexColumns: []
                columns: [
                    {
                        name: 'REPROCESS_YN',
                        renderer: HeaderHtmlRenderer,
                    },
                    {
                        name: 'NEED_REPROCESS',
                        renderer: HeaderHtmlRenderer,
                    },
                ],
            },
            gridColumns: [
                {
                    header: 'No',
                    name: 'RNUM',
                    width: 60,
                    align: 'right',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Completed<br>Translation',
                    name: 'REPROCESS_YN',
                    width: 80,
                    align: 'center',
                    renderer: CellHtmlRenderer,
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Need<br>Translation',
                    name: 'NEED_REPROCESS',
                    width: 80,
                    align: 'center',
                    renderer: CellHtmlRenderer,
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Modified',
                    name: 'MODIFIED',
                    width: 80,
                    align: 'center',
                    renderer: CellHtmlRenderer,
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Title',
                    name: 'TITLE',
                    align: 'left',
                    resizable: false,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Type1',
                    name: 'TYPE1',
                    width: 120,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Type2',
                    name: 'TYPE2',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Reg/Updated Date',
                    name: 'UDT_DT',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Status',
                    name: 'STATUS',
                    width: 80,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
  
                {
                    header: 'Views',
                    name: 'R_COUNT',
                    width: 60,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Downs',
                    name: 'FILE_DOWN_COUNT',
                    width: 60,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },

        };
    },

    created() {
        this.init();

    },
    mounted() {
                // 범위 지정 Datepicker 로 변경
        this.rangePicker = DatePicker.createRangeWithOpener(
            'from-picker-container', 'fromDate', 'icoFromDate',
            'to-picker-container', 'toDate', 'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            (new moment()).add(-3, 'years').toDate(),
            (new moment()).toDate()
        );
    },
    methods: {
        async init() {
            const data = await this.fetchInitData()
                .catch(err => {

                });
            this.roleCd = data.roleCd;
            this.setBulletinType2List(data.bulletinType2List);
            this.setUserLevelList(data.userLevelList);
        },
        fetchInitData() {
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbList.skp`)
                    .then(res => {
                        console.log('SvcBulletin RESPONSE',res);
                        console.log('SvcBulletin RESPONSE DATA',res.data);
                        return res.data;
                    })
            );
        },

        setBulletinType2List(list) {
            list = list.map(item => {
                return item.TYPE2;
            });
            this.bulletinType2List = list;
        },

        setUserLevelList(list) {
            if (this.roleCd === 'S05') {
                list.unshift({CODE_ID: 'ALL', CODE_NAME:'ALL'});
                this.USER_LEVEL = 'ALL';
            } else {
                list = list.filter(item => item.CODE_ID === this.roleCd);
                this.USER_LEVEL = this.roleCd;
            }
            this.userLevelList = list;
        },

        onSearchClick() {
            this.doSearch(1);
        },

        async doSearch(pageNo) {
            const params = this.prepSearchParams(pageNo);
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchSearchResult(params);
            this.setSearchResult(data);
            this.currentPage = pageNo;
            this.lastSearchParams = params;
            SDLUtil.showLoadingBar(false);
        },

        prepSearchParams(pageNo) {
            if (!pageNo) pageNo = 1;

            const format = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            const searchFromAddDt = this.rangePicker.getStartDate()
                ? moment(this.rangePicker.getStartDate()).formatWithJDF(format)
                : '';
            const searchToAddDt = this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(format) : moment().formatWithJDF(format);

            const params = {
                page: pageNo,
                USER_LEVEL: this.USER_LEVEL,
                URGENCY_YN: this.URGENCY,
                TYPE1: this.TYPE1,
                TYPE2: this.TYPE1 === 'Bulletin' ? this.TYPE2_B : this.TYPE2_G,
                TYPE2_G: this.TYPE2_G,
                TYPE2_B: this.TYPE2_B,
                LANGUAGE: 1, // 1 - English
                SEARCH: this.SEARCH, // search type
                TITLE: this.TITLE, // search Keyword
                MODIFIED: this.MODIFIED,
                PERIOD_S: searchFromAddDt,
                PERIOD_E: searchToAddDt,
            };

            console.log('search params', params);
            return params;
        },

        fetchSearchResult(formData) {
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbListSearch.skp`,
                    qs.stringify(formData),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: { searchInfo: 'set' },
                    },
                )
                .then(res => {
                    console.log('SEARCH RESULT =>> ', res);
                    for(const iterator of res.data.rows){
                    	if(iterator.STATUS === 'S'){
                    		iterator.STATUS = 'Success';
                    	}
                    	if(iterator.STATUS === 'R'){
                    		iterator.STATUS = 'Request';
                    	}
                    	if(iterator.STATUS === 'J'){
                    		iterator.STATUS = 'Rejected';
                    	}
                    	if(iterator.STATUS === 'C'){
                    		iterator.STATUS = 'Canceled';
                    	}
                    	if(iterator.STATUS === 'P'){
                    		iterator.STATUS = 'Draft';
                    	}
                    	if(iterator.STATUS === 'N/A'){
                    		iterator.STATUS = 'N/A';
                    	}
                    	
                    }
                    return res.data;
                });


        },

        setSearchResult(data) {
            function color(value) {
                if (value === 'Y') return 'blue';
                if (value === 'N') return 'red';
                return 'auto';
            }
            
            function statusColor(value1,value2) {
                if(value1 === "N/A" || checkTheStatus(value1,value2) ){
                	return 'black';
                }else{
                	return 'blue';
                };
                return 'auto';
            }
            
            function checkTheStatus(value1,value2){
            	if(value1 === "Success" && value2 === "N/A"){
            		return true;
            	}else{
            		return false;
            	}
            }
            
            function toColoredTag(value) {
                return `<span style="color: ${color(value)}">${value}</span>`;
            }
            
            function toStatusColoredTag(value1,value2) {
                return `<span style="color: ${statusColor(value1,value2)}">${value1}</span>`;
            }
            const rows = data.rows.map(row => {
                // Make sure CustomHtmlCell
                row.REPROCESS_YN = toColoredTag(row.REPROCESS_YN);
                row.NEED_REPROCESS = toColoredTag(row.NEED_REPROCESS);
                row.MODIFIED = toColoredTag(row.MODIFIED);
                row.STATUS = toStatusColoredTag(row.STATUS,row.APPROVAL_ID);
                return row;
            });

            this.resultCount = data.count;

            if (typeof data.rows !== 'undefined' &&
                data.rows.count === 0
            ) {
                this.resultCount = 0;
            }

            this.gridData = data.rows;
            this.gridKey += 1;
        },

        onGoToPage(pageNo) {
            // this.lastSearchParams.page = pageNo;
            this.doSearch(pageNo);
        },

        onGridCellClick(event, rowData) {
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);
            console.log('event row', rowData[event.rowKey]);
            if (event.columnName === 'TITLE') {
                this.viewContent(row.SEQ);
            }
            if (event.columnName === 'STATUS' && rowData[event.rowKey].APPROVAL_ID !== 'N/A' && row.STATUS !== 'Draft' ) {
                this.seeApprovalHistoryPop(rowData[event.rowKey].APPROVAL_ID);
            }
        },
        // 결재 이력 보기 팝업
        seeApprovalHistoryPop(approvalId) {
            Vue.$log.info("▶ KnowledgeContentsPopup.vue See Approval History Popup => ", approvalId);
            SDLUtil.show(
                ApprovalHistoryPopup,
                {
                    approvalId: approvalId
                },
                { height: 'auto' }
            );
        },
        viewContent(seq) {
            this.view.seq = seq;
            this.switchMode(MODE.VIEW);
        },

        switchMode(mode) {
            this.mode = mode;
        },

        onBackToList() {
            this.switchMode(MODE.SEARCH);
            this.doSearch(1);  // 이전 view 화면에서 리스트로 이동 시 다시 search 할 수 있도록 추가 
        },

        moveknowledge(ev) {
            let BOARD_ID = localStorage.getItem('sbBoardId');

            if (BOARD_ID == null) BOARD_ID = '';

            this.$router.push({
                path: '/basis/knowledge/knowledgeList',
                query: { BOARD_ID } ,
            });
        },

    },
};
</script>

<style>
.zindex9999 {
    z-index: 9999;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinList.vue